module.exports = __webpack_public_path__ + "static/media/booster_4_right.c02eddcc.png";